import { MY_ORDERS_PARAMS, ORDERS_LINK } from 'layouts/MyProfile/constants';

export const pages = {
  AUTH_PAGE: '/auth?ptype=auth',
  PDP_PAGE: '/{slug}?ptype=product&productId={id}',
  COMBO_PDP: '/{slug}/p/{id}',
  REVIEW_IMAGES_PAGE:
    '/{slug}/review-images/{id}?ptype=review-images&productId={childId}',
  REVIEW_FORM_PAGE:
    '/rating-reviews?ptype=rateAndReview&parentId={id}&childId={childId}&pageSource=PD&trackingSource={trackingSource}',
  ALL_REVIEWS_PAGE: '/{slug}/reviews/{id}?skuId={childId}',
  SEARCH_RESULTS: '/search/result/',
  CHECKOUT_PAGE: '/shoppingBag',
  OFFER_PRODUCTS: '/offer-products',
  PRO_SIGN_UP: '/nykaa-pro-sign-up',
  HOME: '/',
  MY_PROFILE_PAGE: '/myProfile',
  AUTH_PAGE_VERIFY: '/auth/verify?ptype=auth',
  PRIVE_PAGE: '/prive',
  WISHLIST_PAGE: '/wishlist',
  CART_COUPONS: '/coupons?root=cart',
  PAYMENT_PAGE: '/v2/payment?fromCart=true',
};

// FIXME:this is not there for NES
// export const SEARCH_PROXY_PREFIX = '/nyk/aggregator-gludo';
// that's why keeping it empty for now
export const SEARCH_PROXY_PREFIX = '';

export const IN_HOUSE_HELP_CENTER_URLS: Record<'beauty', string> = {
  beauty: '/help-center',
};

export const HELP_CENTER_URLS_POWERED_BY_KAPTURE: Record<string, string> = {
  beauty: '/gateway-api/omsApis/helpCenter?domain=NYKAA',
  men: '/gateway-api/omsApis/helpCenter?domain=NYKAA_MEN',
};

export const MY_ORDERS_URLS: Record<string, string> = {
  beauty: `${ORDERS_LINK}?${MY_ORDERS_PARAMS.PTYPE_PARAM}`,
  men: `${ORDERS_LINK}?${MY_ORDERS_PARAMS.PTYPE_PARAM}`,
};

export const REVIEW_BUNDLE_SOURCE = 'bundle';
export const SNS_PD_PAGE_PREFIX = '/snsp/';
